import Raven from 'raven-js';
import { findNearestWindowWithCopilotChannel } from './domUtils';
const safeQuerySelector = (window, selector) => {
  try {
    var _window$document;
    return window === null || window === void 0 || (_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.querySelector(selector);
  } catch (e) {
    return null;
  }
};
const getMainContentNode = () => {
  const parentWindow = findNearestWindowWithCopilotChannel(window);
  if (!parentWindow) {
    Raven.captureException(new Error('No copilot window found'), {
      extra: {
        identifier: 'copilotPageContext'
      }
    });
    return {
      node: null,
      parentWindow: null
    };
  }

  // For nav variant, we only care about what is in the main page with copilot-app-container
  const node = safeQuerySelector(parentWindow, '.copilot-app-container');
  if (node) {
    return {
      node,
      parentWindow
    };
  }

  // However, copilot-app-container won't exist for fullscreen apps (collboration mode)
  // So we fallback to the page element
  const pageNode = safeQuerySelector(parentWindow, '.page');
  if (pageNode) {
    return {
      node: pageNode,
      parentWindow
    };
  }

  // Fallback to the body element if no copilot-app-container or page element is found
  const body = parentWindow.document.body;
  if (body) {
    return {
      node: body,
      parentWindow
    };
  }
  return {
    node: null,
    parentWindow: null
  };
};
export const getPageTitle = () => {
  const {
    parentWindow
  } = getMainContentNode();
  return (parentWindow === null || parentWindow === void 0 ? void 0 : parentWindow.document.title) || '';
};
export const getPageUrl = () => {
  const {
    parentWindow
  } = getMainContentNode();
  return (parentWindow === null || parentWindow === void 0 ? void 0 : parentWindow.location.href) || '';
};
export const extractContent = parentAppName => {
  const {
    node: mainContentNode
  } = getMainContentNode();
  if (!mainContentNode) {
    Raven.captureException(new Error('No main content node found. Skipping KaaS ingestion.'), {
      extra: {
        identifier: 'copilotPageContext'
      }
    });
    return null;
  }

  // Get text content using innerText which better preserves formatting and spacing
  const textContent = mainContentNode.innerText || '';
  if (!textContent) {
    Raven.captureException(new Error('Failed to extract text content from main content node. Skipping KaaS ingestion.'), {
      extra: {
        identifier: 'copilotPageContext'
      }
    });
    return null;
  }
  Raven.capturePageEvent('copilotPageContext', {
    extra: {
      identifier: 'copilotPageContext',
      // Something static to identify this event in LogFetch as it does not allow filtering based on message name (first arg)
      parentAppName,
      pageSourceBytes: textContent ? new Blob([textContent]).size : 0,
      extractedContentBytes: textContent ? new Blob([textContent]).size : 0
    }
  });
  return {
    content: textContent,
    url: getPageUrl(),
    title: getPageTitle()
  };
};